import ConsentDownload from "./ConsentDownload";
export default ConsentDownload;
